//@flow
import React, { Component } from 'react';
import {
  Default,
  LgTablet,
  SmDesktop,
  LgDesktop
} from '../../../../components/Responsive';
import { ModelListTh } from '../../../../components/ModelListStyles';
import Switch from '../../../../components/Switch';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  orderBy: {
    companyName: number => void,
    numMerchants: number => void,
    processingVolume: number => void,
    transactionFee: number => void,
    commission: number => void
  },
  orderState: {
    companyName: number,
    numMerchants: number,
    processingVolume: number,
    transactionFee: number,
    commission: number
  }
};
export default class PartnersTableHeader extends Component<Props> {
  handleCompanyNameClick = (orderState: number) => {
    this.props.orderBy.companyName(orderState);
  };

  handleNumMerchantsClick = (orderState: number) => {
    this.props.orderBy.numMerchants(orderState);
  };

  handleProcessingVolClick = (orderState: number) => {
    this.props.orderBy.processingVolume(orderState);
  };

  handleTransactionFeeClick = (orderState: number) => {
    this.props.orderBy.transactionFee(orderState);
  };

  handleCommissionClick = (orderState: number) => {
    this.props.orderBy.commission(orderState);
  };

  renderTh = (
    text: string,
    type: string,
    cb: Function,
    right: boolean = true
  ) => (
    <ModelListTh right={right}>
      <Switch
        text={text}
        orderState={this.props.orderState[type]}
        handleClick={orderState => cb(orderState)}
      />
    </ModelListTh>
  );

  render() {
    return (
      <DefaultModelRowTr>
        {this.renderTh(
          'Partner',
          'companyName',
          this.handleCompanyNameClick,
          false
        )}
        <LgDesktop>
          {this.renderTh(
            'Num. of Merchants',
            'numMerchants',
            this.handleNumMerchantsClick
          )}
        </LgDesktop>
        <LgTablet>
          {this.renderTh(
            '# Merchants',
            'numMerchants',
            this.handleNumMerchantsClick
          )}
        </LgTablet>
        <Default>
          {this.renderTh(
            'Processing Vol.',
            'processingVolume',
            this.handleProcessingVolClick
          )}
        </Default>
        <SmDesktop>
          {this.renderTh(
            'Trans. Fee',
            'transactionFee',
            this.handleTransactionFeeClick
          )}
        </SmDesktop>
        <LgDesktop>
          {this.renderTh(
            'Transaction Fee',
            'transactionFee',
            this.handleTransactionFeeClick
          )}
        </LgDesktop>
        {this.renderTh('Commission', 'commission', this.handleCommissionClick)}
      </DefaultModelRowTr>
    );
  }
}
